import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ActivityLogSecurityVerificationFile, ISiteCEPPStatusResult } from '../types/IActivityLog';

export class ActivityLogVerifySecurityFileRequest extends Request<ActivityLogSecurityVerificationFile, ISiteCEPPStatusResult> {
    constructor(params: ActivityLogSecurityVerificationFile) {
        super('verifySecurityFileContentActivateConfig', params);
    }
}
